import { httpRequest } from "@/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Props = {
  page: string | null;
  month: string;
  perPage?: string | null;
};

const donwloadReportBirthdaysToPDF = async ({ page, month, perPage }: Props) => {
  const pageParams = `page=${page || 1}&month=${month}&perPage=${perPage}`;

  const response = await httpRequest.get(
    `/export-patients-birthdays-in-pdf?${pageParams}`,
    {
      responseType: "blob",
    }
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `report-patients-birthdays.pdf`);
  document.body.appendChild(link);
  link.click();
  if (link.parentNode) {
    link.parentNode.removeChild(link);
  } else {
    document.body.removeChild(link);
  }
};

export function useDownloadReportBirthdaysToPDFMutation(props: Props) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => donwloadReportBirthdaysToPDF(props),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["report-birthdays-download-pdf", props.page],
      });
    },
  });
}
